export const ALERTS_ACTIONS = {
  SET_ALERTS: "SET_ALERTS",
};
